import { render, staticRenderFns } from "./ProductAddToPlat.vue?vue&type=template&id=0e6400ca&scoped=true&"
import script from "./ProductAddToPlat.vue?vue&type=script&lang=js&"
export * from "./ProductAddToPlat.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddToPlat.vue?vue&type=style&index=0&id=0e6400ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6400ca",
  null
  
)

export default component.exports